module.exports = __webpack_public_path__ + "img/notificaciones.e70387bd.png";